import { GeneralModel } from "./general.model";

export class Country extends GeneralModel {
}